export default "__VITE_PUBLIC_ASSET__c3f0960d__"